import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { icons } from '../../themes/icons';
import { MobileSidebarDrawer } from '../MobileSidebarDrawer/MobileSidebarDrawer';

type Props = {
  children: React.ReactNode;
};

export const MobileScreenWrapper: React.FC<Props> = ({ children }) => {
  const location = useLocation();
  const [showSidebar, setShowSidebar] = useState<boolean>(false);

  const handleShowSidebar = () => {
    setShowSidebar((prevState) => !prevState);
  };

  React.useEffect(() => {
    setShowSidebar(false);
  }, [location.pathname]);

  return (
    <Container>
      <Header>
        <Link to={'/'} title="home" style={{ textDecoration: 'none' }}>
          <LeftHeaderSide>
            <Logo src="/png/mobile-main-logo.png" alt="mobile-beautypass-logo" />
            <TextContainer>
              <BeautyPassText>Beautypass</BeautyPassText>
              <AdminText>Admin</AdminText>
            </TextContainer>
          </LeftHeaderSide>
        </Link>
        <HamBurgerButton onClick={handleShowSidebar}>
          <icons.BurgerIcon />
        </HamBurgerButton>
      </Header>
      <Content id="mobile-drawer-container">
        {children}
        <MobileSidebarDrawer open={showSidebar} onClose={() => setShowSidebar(false)} />
      </Content>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  height: 100vh;
  overflow: hidden;
`;

const Header = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 16px;
  border: 1px solid #e3e5e4;
  background-color: #fff;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 20;
`;

const Content = styled.div`
  height: calc(100vh - 50px);
  margin-top: 50px;
  overflow: auto;
  position: relative;
  background-color: #fff;

  flex-flow: row nowrap;
  display: flex;
`;

const LeftHeaderSide = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

const Logo = styled.img`
  max-width: 100%;
  height: auto;
`;

const TextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const BeautyPassText = styled.h6`
  color: #080c2e;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

const AdminText = styled.span`
  color: #707070;
  font-size: 13px;
  font-weight: 300;
  line-height: normal;
`;
const HamBurgerButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
`;
